module.exports = {["template-constructor-block-button"]: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n\n    <input class="text"\n           value="'+
((__t=(data.text))==null?'':_.escape(__t))+
'"\n           type="text"\n           autocapitalize="off"\n           autocorrect="off"\n           autocomplete="off"\n           spellcheck="false"/>\n\n';
}
return __p;
},}